<template>
  <div>
    <div class="text-center mt-5" v-if="loading">
      <b-spinner label="Spinning"></b-spinner>
    </div>

    <div v-else>
      <div v-if="file">
        <div v-if="file.active">
          <div class="d-flex justify-content-end">
            <button
              class="btn btn-primary me-2"
              @click="downloadFile()"
              id="download-file"
            >
              <i class="fas fa-download"></i>
            </button>
          </div>

          <div class="preview-area" v-if="isSupportedFileType">
            <div v-if="fileType === 'immagini'">
              <div class="text-center">
                <img :src="url" alt="Preview immagine" class="img-fluid" />
              </div>
            </div>

            <div v-if="fileType === 'video'">
              <video
                :src="url"
                class="w-100"
                controls
                preload="metadata"
              ></video>
            </div>

            <div v-if="fileType === 'audio'">
              <audio :src="url" class="w-100" controls></audio>
            </div>
          </div>

          <div v-else>
            <div v-if="thumbnail" class="text-center">
              <img :src="thumbnail" alt="Preview immagine" class="img-fluid" />
            </div>
            <div class="text-center mt-4" v-else>
              <h5>
                Preview non supportata per questa tipologia di file. <br />
                Scarica il file per visualizzarlo
              </h5>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="text-center mt-5">
            <h5>Questo file non è più disponibile</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemporaryUrlSerivice from "@/services/temporary-url";
import FilesService from "@/services/files";

export default {
  data() {
    return {
      loading: false,
      uuid: null,
      url: "",
      fileType: "",
      fileName: "",
      fileUuid: "",
      file: null,
      thumbnail: undefined,
    };
  },
  computed: {
    isSupportedFileType() {
      const supportedFileTypes = ["immagini", "video", "audio"];

      return supportedFileTypes.includes(this.fileType);
    },
  },
  methods: {
    async getTemporaryUrlFile() {
      this.loading = true;

      try {
        const uuid = this.$route.params.uuid;
        const data = await TemporaryUrlSerivice.getFileByUUID(this.$db, uuid);
        const file = data.data();

        this.file = file;
        this.uuid = uuid;
        this.url = file.url;
        this.fileType = file.fileType.value;
        this.fileName = file.fileName;
        this.fileUuid = file.fileUuid;
        this.thumbnail = file.thumbnail;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    async downloadFile() {
      await FilesService.updateDownloadsCounter(this.$db, this.fileUuid);

      const a = document.createElement("a");

      a.href = this.url;

      a.setAttribute("download", this.fileName);
      a.click();
    },
  },
  mounted() {
    this.getTemporaryUrlFile();
  },
};
</script>

<style lang="scss" scoped>
#download-file {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 999999;
}
</style>



// WEBPACK FOOTER //
// src/pages/public/TemporaryPreview.vue